module.exports = __webpack_public_path__ + "img/dp-xx-ba4.de5d3605.png";